import React from 'react';
import { AlertTriangle } from 'lucide-react';
import Modal from '../../../../components/Modal';
import { Wheel } from '../../../../types';

interface DeleteWheelModalProps {
  isOpen: boolean;
  wheel: Wheel | null;
  isSubmitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteWheelModal: React.FC<DeleteWheelModalProps> = ({
  isOpen,
  wheel,
  isSubmitting,
  onClose,
  onConfirm
}) => {
  if (!wheel) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirmar Exclusão" size="sm">
      <div className="space-y-4">
        <div className="flex gap-3 p-4 rounded-lg bg-bordo/8 border border-bordo/30">
          <AlertTriangle className="w-5 h-5 text-bordo mt-0.5 flex-shrink-0" />
          <p className="text-sm text-tinta leading-relaxed">
            Tem certeza que deseja excluir a roda <strong className="font-display italic">"{wheel.name}"</strong>? Esta ação não pode ser desfeita e todos os dados de giros serão perdidos.
          </p>
        </div>

        <div className="flex justify-end space-x-3 pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-tinta/15 rounded-lg text-sm font-semibold text-tinta-soft bg-white hover:bg-creme-light hover:text-tinta focus:outline-none focus:ring-2 focus:ring-bordo/30 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={isSubmitting}
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            disabled={isSubmitting}
            className="px-4 py-2 rounded-lg text-sm font-bold text-creme bg-bordo hover:bg-bordo-dark focus:outline-none focus:ring-2 focus:ring-bordo/40 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {isSubmitting ? 'Excluindo...' : 'Excluir'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteWheelModal;
